import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Link, type LinkProps } from "react-router";
import styles from "./Button.module.css";

type Variant = "primary" | "secondary" | "ghost" | "danger";
type Size = "md" | "lg" | "sm";

function classes(variant: Variant, size: Size, block?: boolean, extra?: string) {
  return [styles.button, styles[variant], styles[size], block && styles.block, extra].filter(Boolean).join(" ");
}

interface Common { variant?: Variant; size?: Size; block?: boolean; children: ReactNode }

export function Button({ variant = "primary", size = "md", block, busy, className, children, disabled, ...rest }:
  Common & ButtonHTMLAttributes<HTMLButtonElement> & { busy?: boolean }) {
  return (
    <button type="button" {...rest} disabled={disabled || busy} aria-busy={busy || undefined}
            className={classes(variant, size, block, className)}>
      {busy && <span className={styles.spinner} aria-hidden />}
      {children}
    </button>
  );
}

export function ButtonLink({ variant = "primary", size = "md", block, className, children, ...rest }: Common & LinkProps) {
  return <Link {...rest} className={classes(variant, size, block, className)}>{children}</Link>;
}

/** For plain anchors (downloads, external pages). */
export function ButtonAnchor({ variant = "primary", size = "md", block, className, children, ...rest }:
  Common & React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  return <a {...rest} className={classes(variant, size, block, className)}>{children}</a>;
}
